import React, { useRef } from 'react';
import { useDrop } from 'react-dnd';
import { cx } from '../../../api';
import { generateId } from '../../../misc/misc';
import { DragItemType } from '../../share/dnd/DragItemType';
import ListItem from '../../general/list/ListItem';
import Intent from '../../../misc/ObjectActionIntent';
import { className, fromProps } from '../../../lib/className';

/**
 * @param {Object} props
 * @param {cx.ods.processors.DevicePresenceDetector} props.detector
 * @param {function} props.onSelect
 * @param {function} props.onIntent
 */

function PresenceDetectorListItem(props) {
	const uid = useRef(generateId());

	const onClick = () => {
		props.onSelect(props.detector);
	}

	const onDrop = (item) => {
		if (item.type == DragItemType.ACTION_EDIT) {
			props.onIntent(new Intent(null, Intent.Action.Edit, props.detector));
		} else {
			const offset = cx.dom.at.offset(document.getElementById(uid.current));
			props.onIntent(new Intent(null, Intent.Action.Remove, props.detector, { offset }));
		}
	}

	const [dropState, dropRef] = useDrop({
		accept: [DragItemType.ACTION_EDIT, DragItemType.ACTION_REMOVE],
		drop: (item) => onDrop(item),
		collect: monitor => ({
			isOver: monitor.isOver(),
			canDrop: monitor.canDrop()
		})
	});

	return (
		<ListItem
			customRef={dropRef}
			className={className(fromProps(props), { 'droppable': (dropState.isOver && dropState.canDrop) })}
			onClick={onClick}
			id={uid.current}
		>
			{props.detector.name}
		</ListItem>
	);
}

export default PresenceDetectorListItem;